import debounce from "debounce";
import EventEmitter from 'events';

export default class Sticky extends EventEmitter {
  //________________________________________________________ constructor
  // -
  constructor(options = {}) {
    super();
    this._options = {
      el: window.document,
      breakpointDisabled: null,
      topHeightAdjustement: 0,
      ...options
    };

    this._isDisabled = false;
    this._isSticky = false;
    this._isEndSticky = false;
    this._onResize = debounce(this._onResize, 200);

    this._createBound();
    this._grabDom();
    this._addEvents();
    this._onResize();
  }

  //________________________________________________________ public
  // -
  get options() {
    return this._options;
  }

  set breakpointDisabled(breakpoint) {
    this._options.breakpointDisabled = breakpoint;
    this.update();
  }

  set topHeightAdjustement(height) {
    this._options.topHeightAdjustement = height;
    this.update();
  }

  update() {
    this._onResize();
  }

  destroy() {
    window.removeEventListener("scroll", this._onScrollHandler);
    window.removeEventListener("resize", this._onResize);
    this._dom.el.classList.remove("is-sticky", "is-sticky-end");
    this._dom.el.style.top = null;
    this._dom.el.style.width = null;
  }

  //________________________________________________________ events
  // -
  _onScrollHandler() {
    if (this._isDisabled) return;
    this._vars.scrollY = window.pageYOffset;
    requestAnimationFrame(this._onScroll)
  }

  _onScroll() {
    if (this._isDisabled) return;
    const positionSticky = this._cache.containerTop - this._vars.scrollY - this._options.topHeightAdjustement;
    const stickyFilter = positionSticky < 0;

    const stickyBottomWrapperPage = this._vars.scrollY + this._vars.height > this._cache.wrapperTop + this._cache.wrapperHeight;
    const stickyBottomElement = this._vars.scrollY + this._options.topHeightAdjustement + this._cache.containerHeight > this._cache.wrapperTop + this._cache.wrapperHeight;
    const stickyEndFilter = stickyBottomWrapperPage && stickyBottomElement;
    if (this._cache.wrapperHeight < this._cache.containerHeight) {
      this._dom.el.classList.remove("is-sticky", "is-sticky-end");
      return;
    }

    if (stickyFilter && !this._isSticky) {
      this._isSticky = true;
      this._dom.el.classList.add("is-sticky");
      this._dom.el.style.top = `${this._options.topHeightAdjustement}px`;
      this._dom.el.style.width = `${this._cache.containerWidth}px`;
    } else if (!stickyFilter && this._isSticky) {
      this._isSticky = false;
      this._dom.el.style.top = null;
      this._dom.el.style.width = null;
      this._dom.el.classList.remove("is-sticky");
    }
    if (stickyEndFilter && !this._isEndSticky) {
      this._isEndSticky = true;
      this._dom.el.style.top = null;
      this._dom.el.style.width = null;
      this._dom.el.classList.add("is-sticky-end");
    } else if (!stickyEndFilter && this._isEndSticky) {
      this._isEndSticky = false;
      this._dom.el.style.top = `${this._options.topHeightAdjustement}px`;
      this._dom.el.style.width = `${this._cache.containerWidth}px`;
      this._dom.el.classList.remove("is-sticky-end");
    }
  }

  _onResize() {
    if (this._options.breakpointDisabled && window.innerWidth < this._options.breakpointDisabled) {
      this._setDisabled();
      return;
    }
    this._isSticky = false;
    this._isEndSticky = false;
    this._dom.el.classList.remove("is-sticky", "is-sticky-end");
    this._dom.el.style.width = null;
    setTimeout(() => {
      const boudingWrapper = this._dom.wrapper.getBoundingClientRect();
      const boudingContainer = this._dom.el.getBoundingClientRect();
      this._vars = {
        scrollY: window.pageYOffset || document.documentElement.scrollTop,
        height: window.innerHeight || document.documentElement.clientHeight,
      };
      this._cache = {
        windowHeight: window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName("body")[0],
        containerTop: boudingContainer.top + this._vars.scrollY,
        containerHeight: boudingContainer.height,
        containerWidth: boudingContainer.width,
        wrapperTop: boudingWrapper.top + this._vars.scrollY,
        wrapperHeight: boudingWrapper.height,
      };
      if (boudingWrapper.height <= boudingContainer.height) {
        this._setDisabled();
        return;
      }
      if (this._isDisabled) {
        this._isDisabled = false;
        this.emit('enable');
      }
      this._onScrollHandler();
    });
  }
  //________________________________________________________ private
  // -
  _createBound() {
    ["_onScroll", "_onScrollHandler", "_onResize"].forEach((fn) => (this[fn] = this[fn].bind(this)));
  }

  _setDisabled() {
    if (this._isDisabled) return;
    this._isDisabled = true;
    this._dom.el.classList.remove("is-sticky", "is-sticky-end");
    this._dom.el.style.top = null;
    this._dom.el.style.width = null;
    this.emit('disable');
  }

  _grabDom() {
    this._dom = {};
    this._dom.el = this._options.el.querySelector("[data-sticker-element]");
    this._dom.wrapper = this._options.el.querySelector("[data-sticker-wrapper]");
  }

  _addEvents() {
    setTimeout(() => {
      window.addEventListener("scroll", this._onScrollHandler);
      window.addEventListener("resize", this._onResize);
    });
  }
}
